import { render, staticRenderFns } from "./SubscriberDetails.vue?vue&type=template&id=126aa3b1&"
import script from "./SubscriberDetails.vue?vue&type=script&lang=ts&"
export * from "./SubscriberDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports